"use client";

import React from "react";
import styles from "./styles/text-to-speech-page.module.scss";
import TextToAudioInput from "@/components/pages/text-to-music/components/text-to-audio-input";
import GenerateSpeechButton from "@/components/pages/text-to-speech/components/generate-speech-button";
import ProgressBar from "@/components/pages/convert/components/progress-bar";
import StemResultItem from "@/components/pages/stem-splitter/components/stem-result-item";
import SpeechVoices from "@/components/pages/text-to-speech/components/speech-voices";
import SpeechLanguagesDropdown from "@/components/pages/text-to-speech/components/speech-languages-dropdown";
import SelectedVoice from "@/components/pages/convert/components/convert-sidebar/components/selected-voice";
import ServicePageHeader from "@/components/common/service-page-header";
import { useTextToSpeech } from "@/components/pages/text-to-speech/hooks/use-text-to-speech";
import Loader from "@/components/common/loader";
import {
  shouldDisplayProgress,
  shouldDisplayStartProcessButton,
} from "@/hooks/progress-context/use-anonymous-progress-provider";

const TextToSpeechPage = () => {
  const {
    settings,
    selectedModel,
    result,
    handleTextChange,
    cancelTextToSpeech,
    isCancelling,
    maxTextLength,
    progressContext,
  } = useTextToSpeech();

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <ServicePageHeader
          title={
            <>
              Text To <span>Speech</span>
            </>
          }
          description={
            "Select a voice, type a text and generate speech you want"
          }
        />
      </div>
      <div className={styles.header}>
        {selectedModel ? (
          <SelectedVoice
            selectedModel={selectedModel}
            switchVoiceModalType={"tts_voice_selector_modal"}
          />
        ) : (
          <SpeechVoices />
        )}
      </div>

      <div className={styles.input_wrapper}>
        <div className={styles.input_header_text}>
          Type in the box below to generate speech using your selected AI model.
        </div>

        {maxTextLength ? (
          <TextToAudioInput
            settings={settings}
            handleTextChange={handleTextChange}
            placeholder={"Add text here"}
            maxLength={maxTextLength}
          />
        ) : (
          <Loader />
        )}
      </div>
      <div className={styles.languages_dropdown}>
        <SpeechLanguagesDropdown />
      </div>

      {shouldDisplayStartProcessButton(progressContext.status) && (
        <GenerateSpeechButton />
      )}

      {shouldDisplayProgress(progressContext.status) && (
        <ProgressBar
          percent={progressContext.percent}
          descriptionCode={progressContext.description}
          onCancel={cancelTextToSpeech}
          isCancelling={isCancelling}
        />
      )}

      {progressContext.status === "complete" && (
        <div className={styles.results}>
          <p>{progressContext.result}</p>
          <StemResultItem
            url={result!}
            stem={"Result"}
            id={progressContext.processId}
            featureType={"tts"}
          />
        </div>
      )}
    </div>
  );
};

export default TextToSpeechPage;
